module.exports = __webpack_public_path__ + "static/media/Stock_Exchange_Icon.e89583de.svg";